import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import CompetitionModal from '../Competition';
import Header from './Header.js';
import {
  WORKSHOP_COLS,
  COMPETITION_COLS,
  DEFAULTSORTED,
  DEFAULTPAGESIZE
} from './table.conf.js';
import { updateInPath, nullsToStrings } from '../../../../common/utils';
import { Dimmer } from 'semantic-ui-react';

class Competitions extends Component {
  constructor(props) {
    super();

    this.state = {
      competitionModal: {
        open: false,
        data: {}
      },
      eventType: null
    };
  }

  handleCompetitionModalSave = (data) => {
    this.props.onCompetitionSave(data);
    this.setState(s => updateInPath(s, 'competitionModal.open', false));
  }

  handleCompetitionModalClose = () => {
    this.setState(s => updateInPath(s, 'competitionModal.open', false));
  }

  handleCompetitionModalEdit = async ({ event, competitionId }) => {
    this.setState(s => updateInPath(s, 'dimmer', true));
    const c = await this.props.onCompetitionView(event.id, competitionId);
    this.setState(s => updateInPath(s, 'competitionModal.data', nullsToStrings(c)));
    this.setState(s => updateInPath(s, 'competitionModal.open', true));
    this.setState(s => updateInPath(s, 'dimmer', false));
  }

  handleCompetitionModalAdd = () => {
    this.setState(s => updateInPath(s, 'competitionModal.data', null));
    this.setState(s => updateInPath(s, 'competitionModal.open', true));
  }

  handleSelectEvent = (filters, selectedItem) => {
    this.setState(s => updateInPath(s, 'eventType', selectedItem.type));
    this.props.refresh(filters);
  }
  
  render() {
    const { data, loading } = this.props;
    const { competitionModal, dimmer, eventType } = this.state;

    return (
      <div>
        <Dimmer inverted active={dimmer} />
        { competitionModal.open && <CompetitionModal
                                     open={competitionModal.open}
                                     data={competitionModal.data}
                                     onSave={this.handleCompetitionModalSave}
                                     onClose={this.handleCompetitionModalClose} />}
        <Header
          onAddCompetition={this.handleCompetitionModalAdd}
          onSelectEvent={this.handleSelectEvent}
        />
        <ReactTable
          className='-striped -highlight'
          data={data}
          loading={loading}
          getTrProps={(state, rowInfo) => ({
            onClick: e => this.handleCompetitionModalEdit(rowInfo.original)
          })}
          columns={eventType === 'WORKSHOP' ? WORKSHOP_COLS : COMPETITION_COLS}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE} />
      </div>
    );
  }
};

export default Competitions;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competitions/index.js